import { render, staticRenderFns } from "./EditTournament.vue?vue&type=template&id=3c527ddd&lang=pug"
import script from "./EditTournament.vue?vue&type=script&lang=js"
export * from "./EditTournament.vue?vue&type=script&lang=js"
import style0 from "./EditTournament.vue?vue&type=style&index=0&id=3c527ddd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports